const getTasteStrFromTag = (product: any): string => {
  // Only match tags like 'Taste Black-Cherry Wine-Gums' - hyphens join the
  // words of a single flavour
  const tasteTag: string = product.tags.find((tag: string) => /^taste\s/i.test(tag));

  return tasteTag ? tasteTag.split(' ').slice(1).join(', ').replace(/-/g, ' ') : '';
};

export default getTasteStrFromTag;
